import styled from "styled-components";
import InputError from "../../../styles/input/InputError.styled";

export const StyledTextInputContainer = styled.div`
  ${InputError} {
    margin-top: 4px;
  }
`;
